import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider, FormControl, FormControlLabel, FormLabel, Grid, Input, InputAdornment, makeStyles, MenuItem, Paper, Radio, RadioGroup, Select, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography
} from '@material-ui/core';
import BlurLinearIcon from '@material-ui/icons/BlurLinear';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import FlashAutoIcon from '@material-ui/icons/FlashAuto';
import PostAddIcon from '@material-ui/icons/PostAdd';
import SaveIcon from '@material-ui/icons/Save';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ConcealableContainer from 'src/components/ConcealableContainer';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, distinct, getUser, modifyAnObjectInArray, sc, setCounting } from 'src/utils/Common';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tableCell: {

  },
  selectedTableCell: {
    color: '#FF9800'
  },
  submitButton: {
    marginTop: theme.spacing(4),
    width: '100%'
  },
  container: {
    maxHeight: 350,
    minHeight: 350,
  },
  containerSag: {
    maxHeight: 282,
    minHeight: 282,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  selectedRow: {
    backgroundColor: "#424242",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function WarehouseCreate() {
  const classes = useStyles();
  const user = getUser();
  const config = { headers: { 'Content-Type': 'application/json' } };
  const [selectedWarehouse, setSelectedWarehouse] = useState(0);
  const [Uyari, setUyari] = React.useState("");
  const [Loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [selectedWarehouseCounting, setSelectedWarehouseCounting] = React.useState(false);
  const [warehouses, setWarehouses] = useState([]);
  /* Warehouse Functions */
  const [warehouseRows, setWarehouseRows] = useState([]);
  const [warehousePage, setWarehousePage] = React.useState(0);
  const [warehouseRowsPerPage, setWarehouseRowsPerPage] = React.useState(5);
  const handleChangeWarehousePage = (event, newPage) => setWarehousePage(newPage);
  const [SiraOpen, setSiraOpen] = React.useState(false);
  const [SayimOpen, setSayimOpen] = React.useState(false);
  const [SiraParam, setSiraParam] = React.useState(1);
  const [KatParam, setKatParam] = React.useState(1);
  const [KutuParam, setKutuParam] = React.useState(1);
  const [value, setValue] = React.useState(0);

  const handleRadioChange = (event) => {
    setValue(parseInt(event.target.value));
  };


  const handleOnCreateNewWarehouse = (id) => {
    setWarehousePage(Math.floor((warehouseRows.length) / warehouseRowsPerPage));
    setWarehouses([...warehouseRows, { id, warehouseDef: "Yeni Depo", isWarehouseActive: '0', iconType: "Check" }])
    setWarehouseRows([...warehouseRows, { id, warehouseDef: "Yeni Depo", isWarehouseActive: '0', iconType: "Check" }])
  }
  const handleWarehouseRowCheckIcon = (id) => {
    setWarehouseRows(modifyAnObjectInArray(warehouseRows, id, 'iconType', 'Save'))
  };
  const handleWarehouseRowSaveIcon = (id) => {

    var Deger = warehouseRows.filter(item => item.id === id);

    if (id === -Infinity) {
      id = -1;
    }

    const data = {
      Id: id,
      WarehouseDef: Deger[0].warehouseDef,
      IsWarehouseActive: Deger[0].isWarehouseActive,
      User: user.OrganizationUserId,
      ServiceShopId: user.ServiceShopId
    };

    axios.post('/SetWarehouse', data, config)
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode && parseInt(data.ErrorCode) === 0) {
          axios.get(`GetWarehouseDefDetails/${user.ServiceShopId}`)
            .then(response => {
              setWarehouses(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, iconType: "Edit" } })));
              setWarehouseRows(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, selectedRow: false, iconType: "Edit" } })));
              setWarehouseDetails(distinct(response.data.map(w => { return { id: w.WarehouseLocationId, warehouseId: w.WarehouseId, warehouseDetailDef: w.WarehouseLocationDef, lvl1: w.Lvl1, lvl2: w.Lvl2, lvl3: w.Lvl3, lvl4: w.Lvl4, isWarehouseDetailActive: w.IsWarehouseLocationActive } })));
              CreateWareHouseAddress(user.ServiceShopId);
            }).catch(error => {

            });


        }
        else {
          setUyari(data.ErrorDescription);
          setWarehouseRows(modifyAnObjectInArray(warehouseRows, id, 'iconType', 'Check'))
          setOpen(true);
        }
      }).catch((error) => {
        setUyari('Hata Oluştu.Hata: ' + error.message);
        setWarehouseRows(modifyAnObjectInArray(warehouseRows, id, 'iconType', 'Check'))
        setOpen(true);
        setLoading(false);
      });
  }
  const handleWarehouseRowEditIcon = (id) => {
    setWarehouseRows(modifyAnObjectInArray(warehouseRows, id, 'iconType', 'Check'))
  };
  const handleOnWarehouseRowChange = (row, id, name, value) => {
    setWarehouseRows(modifyAnObjectInArray(warehouseRows, id, name, value))
    row.name = value;
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseSira = () => {
    setSiraOpen(false);
  };
  const handleCloseSayim = () => {
    setSayimOpen(false);
  };
  const SiraAc = (event) => {
    setSiraOpen(true);
  };
  const SayimAc = (event) => {
    setSayimOpen(true);
  };

  const handleInputChange = event => {
    setSiraParam(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleInputChangeKat = event => {
    setKatParam(event.target.value === '' ? '' : Number(event.target.value));
  };
  const handleInputChangeKutu = event => {
    setKutuParam(event.target.value === '' ? '' : Number(event.target.value));
  };


  const handleChangeWarehouseRowsPerPage = (event) => {
    setWarehouseRowsPerPage(+event.target.value);
    setWarehousePage(0);
  };
  const handleWarehouseOnClick = (id) => {
    if (selectedWarehouse === id) return;
    setSelectedWarehouse(id);
    setWarehouseRows(warehouseRows.map(el => el.id === id ? { ...el, selectedRow: true } : { ...el, selectedRow: false }));
    setSelectedWarehouseCounting(warehouseDetails.filter(item => item.warehouseId === id).map(item => item.counting));
    setWarehouseDetailRows(warehouseDetails.filter(item => item.warehouseId === id));
  };
  const DepoAdresTopluOlustur = () => {
    if (selectedWarehouse < 1) {
      setUyari("Lütfen Depo Seçiniz!...");
      setOpen(true);
      return;
    }
    setSiraOpen(false);
    setLoading(true);
    axios.get('/SetAllWarehouseAddress/' + selectedWarehouse + '/' + SiraParam + '/' + user.OrganizationUserId + '/' + KatParam + '/' + KutuParam)
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode && parseInt(data.ErrorCode) === 0) {
          axios.get(`GetWarehouseDefDetails/${user.ServiceShopId}`)
            .then(response => {
              setWarehouses(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, iconType: "Edit" } })));
              setWarehouseRows(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, selectedRow: false, iconType: "Edit" } })));
              setWarehouseDetails(distinct(response.data.map(w => { return { id: w.WarehouseLocationId, warehouseId: w.WarehouseId, warehouseDetailDef: w.WarehouseLocationDef, lvl1: w.Lvl1, lvl2: w.Lvl2, lvl3: w.Lvl3, lvl4: w.Lvl4, isWarehouseDetailActive: w.IsWarehouseLocationActive, iconType: "Edit" } })));
              CreateWareHouseAddress(user.ServiceShopId);
              setUyari("İşleminiz başarı ile gerçekleştirildi!...");
              setOpen(true);
              //  handleWarehouseOnClick(selectedWarehouse);
              var Detail = (distinct(response.data.map(w => { return { id: w.WarehouseLocationId, warehouseId: w.WarehouseId, warehouseDetailDef: w.WarehouseLocationDef, lvl1: w.Lvl1, lvl2: w.Lvl2, lvl3: w.Lvl3, lvl4: w.Lvl4, isWarehouseDetailActive: w.IsWarehouseLocationActive } })));
              setSelectedWarehouse(selectedWarehouse);
              setSelectedWarehouseCounting(Detail.filter(item => item.warehouseId === selectedWarehouse).map(item => item.counting));
              setWarehouseDetailRows(Detail.filter(item => item.warehouseId === selectedWarehouse));

              // setWarehouseDetailPage(0);
            }).catch(error => {

            });
        }
        else {
          setUyari(data.ErrorDescription);
          setOpen(true);
        }
        setLoading(false);
      }).catch((error) => {
        setUyari('Hata Oluştu.Hata: ' + error.message);
        setOpen(true);
        setLoading(false);
      });
  }
  /* WarehouseDetail Functions */
  const [warehouseDetails, setWarehouseDetails] = useState([]);
  const [warehouseDetailRows, setWarehouseDetailRows] = useState([]);
  const [warehouseDetailPage, setWarehouseDetailPage] = React.useState(0);
  const [warehouseDetailRowsPerPage, setWarehouseDetailRowsPerPage] = React.useState(5);
  const handleChangeWarehouseDetailPage = (event, newPage) => setWarehouseDetailPage(newPage);
  const handleOnCreateNewWarehouseDetail = (id) => {
    setWarehouseDetails([...warehouseDetails, { id: id, warehouseId: selectedWarehouse, warehouseDetailDef: "", lvl1: "", lvl2: "", lvl3: "", lvl4: "", isWarehouseDetailActive: '1', iconType: "Check" }]);
    setWarehouseDetailRows([...warehouseDetailRows, { id: id, warehouseId: selectedWarehouse, warehouseDetailDef: "", lvl1: "", lvl2: "", lvl3: "", lvl4: "", isWarehouseDetailActive: '1', iconType: "Check" }]);
    setWarehouseDetailPage(Math.floor((warehouseDetailRows.length) / warehouseDetailRowsPerPage));
  }
  const handleWarehouseDetailRowCheckIcon = (id) => setWarehouseDetailRows(modifyAnObjectInArray(warehouseDetailRows, id, 'iconType', 'Save'));
  const handleWarehouseDetailRowSaveIcon = (id) => {
    var Deger = warehouseDetailRows.filter(item => item.id === id);
    const dataReq = {
      Id: id,
      Lvl1: Deger[0].lvl1,
      Lvl2: Deger[0].lvl2,
      Lvl3: Deger[0].lvl3,
      Lvl4: Deger[0].lvl4,
      IsWarehouseDetailActive: Deger[0].isWarehouseDetailActive,
      User: user.OrganizationUserId,
      WarehouseDetailDef: Deger[0].warehouseDetailDef,
      WarehouseId: Deger[0].warehouseId
    };


    axios.post('/SetWarehouseDetail', dataReq, config)
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode && parseInt(data.ErrorCode) === 0) {
          setWarehouseDetails(warehouseDetails.map(el => el.id === id ? {
            ...el
            , id: dataReq.id
            , iconType: 'Edit'
            , lvl1: dataReq.Lvl1
            , lvl2: dataReq.Lvl2
            , lvl3: dataReq.Lvl3
            , lvl4: dataReq.Lvl4
            , isWarehouseDetailActive: dataReq.IsWarehouseDetailActive
            , warehouseDetailDef: dataReq.WarehouseDetailDef
          } : el));
          setWarehouseDetailRows(warehouseDetailRows.map(el => el.id === id ? { ...el, id: data.ErrorDescription, iconType: 'Edit' } : el));
          CreateWareHouseAddress(user.ServiceShopId);
        }
        else {
          setUyari(data.ErrorDescription);
          setOpen(true);
          setWarehouseDetailRows(modifyAnObjectInArray(warehouseDetailRows, id, 'iconType', 'Check'));
        }
      }).catch((error) => {
        setUyari('Hata Oluştu.Hata: ' + error.message);
        setWarehouseDetailRows(modifyAnObjectInArray(warehouseDetailRows, id, 'iconType', 'Check'));
        setOpen(true);
        setLoading(false);
      });

  }
  const handleWarehouseDetailRowEditIcon = (id) => setWarehouseDetailRows(modifyAnObjectInArray(warehouseDetailRows, id, 'iconType', 'Check'));
  const handleOnWarehouseDetailRowChange = (row, id, name, value) => {

    // setWarehouseDetailRows(modifyAnObjectInArray(warehouseDetailRows, id, name, value));

    var lvl1p = "";
    var lvl2p = "";
    var lvl3p = "";
    var lvl4p = "";
    var warehouseDetailDefp = "";
    var isWarehouseDetailActivep = "";

    if (name === "lvl1") {
      lvl1p = value;
    } else {
      lvl1p = row.lvl1;
    }
    if (name === "lvl2") {
      lvl2p = value;
    } else {
      lvl2p = row.lvl2;
    }
    if (name === "lvl3") {
      lvl3p = value;
    } else {
      lvl3p = row.lvl3;
    }
    if (name === "lvl4") {
      lvl4p = value;
    } else {
      lvl4p = row.lvl4;
    }
    if (name === "lvl4") {
      lvl4p = value;
    } else {
      lvl4p = row.lvl4;
    }
    if (name === "warehouseDetailDef") {
      warehouseDetailDefp = value;
    } else {
      warehouseDetailDefp = row.warehouseDetailDef;
    }
    if (name === "isWarehouseDetailActive") {
      isWarehouseDetailActivep = value;
    } else {
      isWarehouseDetailActivep = row.isWarehouseDetailActive;
    }
    var AdresTanim = "";
    if (name === "warehouseDetailDef" || name === "isWarehouseDetailActive") {
      AdresTanim = warehouseDetailDefp;
    } else {
      AdresTanim = lvl1p + "-" + lvl2p + "-" + lvl3p + "-" + lvl4p;
    }
    AdresTanim = AdresTanim.split('-').filter(a => a.length > 0).join('-');
    row.warehouseDetailDef = AdresTanim;
    row.isWarehouseDetailActive = isWarehouseDetailActivep;
    row.lvl1 = lvl1p;
    row.lvl2 = lvl2p;
    row.lvl3 = lvl3p;
    row.lvl4 = lvl4p;

    var Data = [...warehouseDetailRows];
    setWarehouseDetailRows(Data);

  };
  const handleChangeWarehouseDetailRowsPerPage = (event) => {
    setWarehouseDetailRowsPerPage(+event.target.value);
    setWarehouseDetailPage(0);
  };

  useEffect(() => {
    console.clear();
    setValue(user.Counting);
    setLoading(true);
    axios.get(`GetWarehouseDefDetails/${user.ServiceShopId}`)
      .then(response => {
        setWarehouses(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, iconType: "Edit" } })));
        setWarehouseRows(distinct(response.data.map(w => { return { id: w.WarehouseId, warehouseDef: w.WarehouseDef, isWarehouseActive: w.IsWarehouseActive, selectedRow: false, iconType: "Edit" } })));
        setWarehouseDetails(distinct(response.data.map(w => { return { id: w.WarehouseLocationId, warehouseId: w.WarehouseId, warehouseDetailDef: w.WarehouseLocationDef, lvl1: w.Lvl1, lvl2: w.Lvl2, lvl3: w.Lvl3, lvl4: w.Lvl4, isWarehouseDetailActive: w.IsWarehouseLocationActive } })));
        CreateWareHouseAddress(user.ServiceShopId);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);




  const SayimIslemleriKabul = () => {
    axios.get('/SetWarehouseCountingStatus/' + user.ServiceShopId + '/' + selectedWarehouse + '/' + value + '/' + user.OrganizationUserId).then(response => {
      setLoading(false);
      let ResponseData = response.data[0];
      if (parseInt(ResponseData.ErrorCode) === 0) {
        setUyari("İşleminiz başarı ile gerçekleştirildi...");
        setCounting(value);
      } else {
        setUyari(ResponseData.ErrorDescription);
      }

      setOpen(true);
    }).catch(error => {
      console.log(error.message);
    });

  }

  const SayimIslemleri = () => {

    if (selectedWarehouse < 1) {
      setUyari("Lütfen Depo Seçiniz!...");
      setOpen(true);
      return;
    }

    setSayimOpen(false);
    var kontrol = "";
    if (value === 0) {
      kontrol = "DURDURULACAKTIR!...";
    } else {
      kontrol = "BAŞLATILACAKTIR!...";
    }
    var Uyari = "Sayım işlemi " + kontrol + " Devam etmek istediğinizden Eminmisiniz?"
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => SayimIslemleriKabul()
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="oasis Yönetimi Depo Tanım" />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Paper>
                  <CardHeader title="Tanımlı Depo Listesi" />
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Depo Açıklama"
                        id="standard-start-adornment"
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => { setWarehouseRows(warehouses.filter(item => sc(item.warehouseDef, event.target.value))); }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table className={classes.table} size="small"
                        stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell align="left">Depo Adı</TableCell>
                            <TableCell align="left">Durum</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {warehouseRows.slice(warehousePage * warehouseRowsPerPage, warehousePage * warehouseRowsPerPage + warehouseRowsPerPage).map((row, index) => (
                            <TableRow key={index} className={row.selectedRow === true && classes.selectedRow}
                              onClick={() => { handleWarehouseOnClick(row.id); setWarehouseDetailPage(0); }}>
                              <TableCell align="left" className={classes.tableCell}>
                                {row.iconType === "Save" ?
                                  <SaveIcon color="primary" onClick={() => handleWarehouseRowSaveIcon(row.id)} /> :
                                  (row.iconType === "Check" ?
                                    <CheckIcon color="primary" onClick={() => handleWarehouseRowCheckIcon(row.id)} /> :
                                    <EditIcon color="primary" onClick={() => handleWarehouseRowEditIcon(row.id)} />)}
                              </TableCell>
                              <TableCell align="left" className={row.selectedRow && classes.selectedTableCell}>
                                {row.iconType === "Check" ? (
                                  <Input
                                    value={row.warehouseDef}
                                    name={row.warehouseDef}
                                    onChange={event => { handleOnWarehouseRowChange(row, row.id, 'warehouseDef', event.target.value); }}
                                    // className={classes.input}
                                    className={row.selectedRow && classes.selectedTableCell}
                                  />
                                ) : row.warehouseDef}
                              </TableCell>
                              <TableCell align="left" className={row.selectedRow && classes.selectedTableCell}>
                                {row.iconType === "Check" ? (
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={row.isWarehouseActive}
                                    className={row.selectedRow && classes.selectedTableCell}
                                    onChange={event => { handleOnWarehouseRowChange(row, row.id, 'isWarehouseActive', event.target.value); }}
                                  >
                                    <MenuItem value={'1'}>Aktif</MenuItem>
                                    <MenuItem value={'0'}>Pasif</MenuItem>
                                  </Select>
                                ) : (row.isWarehouseActive === '1' ? "Aktif" : "Pasif")}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      component="div"
                      count={warehouseRows.length}
                      rowsPerPage={warehouseRowsPerPage}
                      page={warehousePage}
                      onChangePage={handleChangeWarehousePage}
                      onChangeRowsPerPage={handleChangeWarehouseRowsPerPage}
                    />
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      endIcon={<PostAddIcon />}
                      onClick={() => handleOnCreateNewWarehouse((Math.abs(Math.min(...warehouseRows.map(user => user.id))) * -1) - 1)}
                    >Depo Tanımla</Button>
                  </CardActions>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={9} >
                <Paper>
                  <CardHeader
                    title={(selectedWarehouse <= 0) ? "Tanımlı Depo Adreslerini Görüntülemek İçin Kayıtlı Bir Depo Seçiniz"
                      : `${warehouses.filter(item => item.id === selectedWarehouse).map(item => item.warehouseDef)} Tanımlı Depo Adres Listesi`}

                  />
                  <Divider />
                  <CardActions>
                    <Button
                      variant="contained"
                      className={classes.button}
                      color="secondary"
                      endIcon={<BlurLinearIcon></BlurLinearIcon>}
                      onClick={event => SayimAc(event)}
                    >
                      Depo Sayım
                      </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      color="secondary"
                      endIcon={<FlashAutoIcon></FlashAutoIcon>}
                      onClick={event => SiraAc(event)}
                    >
                      Otomatİk Adres Tanımla
                      </Button>
                  </CardActions>
                  <Divider />
                  {
                    selectedWarehouse > 0
                    && (
                      <div>
                        <CardActions>
                          <FormControl fullWidth className={classes.margin}>
                            <TextField
                              label="Adres Tanım"
                              id="standard-start-adornment"
                              className={clsx(classes.margin, classes.textField)}
                              onChange={event => setWarehouseDetailRows(warehouseDetails.filter(item => item.warehouseId === selectedWarehouse).filter(item => sc(item.warehouseDetailDef, event.target.value)))}
                              InputProps={{
                                endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
                              }}
                            />
                          </FormControl>
                        </CardActions>
                        <CardContent>
                          <TableContainer className={classes.containerSag}>
                            <Table className={classes.table} size="small"
                              stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell align="left">Adres Tanım</TableCell>
                                  <TableCell align="left">Sıra</TableCell>
                                  <TableCell align="left">Kat</TableCell>
                                  <TableCell align="left">Raf</TableCell>
                                  <TableCell align="left">Kutu</TableCell>
                                  <TableCell align="left">Durum</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {warehouseDetailRows.sort((a, b) => {
                                  if (a.id < 1 || a.iconType === "Check" || a.iconType === "Save" || b.iconType === "Check" || b.iconType === "Save") return 0;
                                  let fa = a.warehouseDetailDef.toLowerCase(),
                                    fb = b.warehouseDetailDef.toLowerCase();
                                  if (fa < fb) {
                                    return -1;
                                  }
                                  if (fa > fb) {
                                    return 1;
                                  }
                                  return 0;
                                }).slice(warehouseDetailPage * warehouseDetailRowsPerPage, warehouseDetailPage * warehouseDetailRowsPerPage + warehouseDetailRowsPerPage).map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Save" ?
                                        <SaveIcon color="primary" onClick={() => handleWarehouseDetailRowSaveIcon(row.id)} /> :
                                        (row.iconType === "Check" ?
                                          <CheckIcon color="primary" onClick={() => handleWarehouseDetailRowCheckIcon(row.id)} /> :
                                          <EditIcon color="primary" onClick={() => handleWarehouseDetailRowEditIcon(row.id)} />)}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Input
                                          value={row.warehouseDetailDef}
                                          name={row.warehouseDetailDef}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'warehouseDetailDef', event.target.value); }}
                                          className={classes.input}
                                        />
                                      ) : row.warehouseDetailDef}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Input
                                          value={row.lvl1}
                                          name={row.lvl1}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'lvl1', event.target.value); }}
                                          className={classes.input}
                                        />
                                      ) : row.lvl1}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Input
                                          value={row.lvl2}
                                          name={row.lvl2}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'lvl2', event.target.value); }}
                                          className={classes.input}
                                        />
                                      ) : row.lvl2}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Input
                                          value={row.lvl3}
                                          name={row.lvl3}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'lvl3', event.target.value); }}
                                          className={classes.input}
                                        />
                                      ) : row.lvl3}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Input
                                          value={row.lvl4}
                                          name={row.lvl4}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'lvl4', event.target.value); }}
                                          className={classes.input}
                                        />
                                      ) : row.lvl4}
                                    </TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {row.iconType === "Check" ? (
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={row.isWarehouseDetailActive}
                                          onChange={event => { handleOnWarehouseDetailRowChange(row, row.id, 'isWarehouseDetailActive', event.target.value); }}
                                        >
                                          <MenuItem value={'1'}>Aktif</MenuItem>
                                          <MenuItem value={'0'}>Pasif</MenuItem>
                                        </Select>
                                      ) : (row.isWarehouseDetailActive === '1' ? "Aktif" : "Pasif")}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination rowsPerPageOptions={[]}
                            component="div"
                            count={warehouseDetailRows.length}
                            rowsPerPage={warehouseDetailRowsPerPage}
                            page={warehouseDetailPage}
                            onChangePage={handleChangeWarehouseDetailPage}
                            onChangeRowsPerPage={handleChangeWarehouseDetailRowsPerPage}
                          />
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            variant="contained"
                            color="secondary"
                            className={classes.submitButton}
                            endIcon={<PostAddIcon />}
                            onClick={() => handleOnCreateNewWarehouseDetail((Math.abs(Math.min(...warehouseDetailRows.map(user => user.id))) * -1) - 1)}>
                            Depo Adres Tanımla
                          </Button>
                        </CardActions>
                      </div>
                    )
                  }
                </Paper>
              </Grid>
            </Grid>
            <ConcealableContainer show={(warehouseRows.filter(a => a.iconType === "Save").length > 0) || (warehouseDetailRows.filter(a => a.iconType === "Save").length > 0)}>
              <Alert severity="warning">{"Kaydedilmemiş verileriniz bulunuyor. Kaydetmeden sayfadan çıkarsanız veriler kaybedilecektir."}</Alert>
            </ConcealableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={SiraOpen}
        TransitionComponent={Transition}
        maxWidth='lg'
        keepMounted
        onClose={handleCloseSira}
      >
        <DialogTitle>{"Otomatik Adres Oluşturma!..."}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4}>
              <Typography id="input-slider" gutterBottom>
                Kaç Sıra Var?
            </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography id="input-slider" gutterBottom>
                Bir Sırada Max Kaç Kat Var?
            </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography id="input-slider" gutterBottom>
                Bir Katta Max Kaç Kutu Var?
            </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Input
                className={classes.input}
                value={SiraParam}
                margin="dense"
                fullWidth
                onChange={handleInputChange}

              />
            </Grid>

            <Grid item xs={4} sm={4}>
              <Input
                className={classes.input}
                value={KatParam}
                margin="dense"
                fullWidth
                onChange={handleInputChangeKat}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <Input
                className={classes.input}
                value={KutuParam}
                margin="dense"
                fullWidth
                onChange={handleInputChangeKutu}

              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <img src={"/images/DepoYapi.jpg"} alt="nice" style={{ width: 1000, height: 'auto' }} ></img>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={DepoAdresTopluOlustur}
            color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSira} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
      </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SayimOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSayim}
      >
        <DialogTitle>{"Sayım başlatma aktif edildiğinde depo giriş ve çıkışlar durdurulacaktır!..."}</DialogTitle>
        <DialogContent>
          <FormControl
            component="fieldset"
            className={classes.formControl}
          >
            <FormLabel component="legend">
              Sayım Başlatma/Kapatma İşlemleri
        </FormLabel>
            <RadioGroup
              aria-label="quiz"
              name="quiz"
              value={value}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="Sayım Başlatıldı"
              />
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="Sayım Durduruldu"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={SayimIslemleri}
            color="primary">
            Onayla
          </Button>
          <Button onClick={handleCloseSayim} color="primary">
            Vazgeç
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}

export default WarehouseCreate;
